import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import {
  TwitterShareButton,
  PinterestShareButton,
  FacebookShareButton,
  GooglePlusShareButton,
  TumblrShareButton,
  RedditShareButton,
  TwitterIcon,
  PinterestIcon,
  FacebookIcon,
  GooglePlusIcon,
  TumblrIcon,
  RedditIcon,
  PinterestShareCount,
} from 'react-share'

const styles = (theme) => ({
  root: {
    width: '100%',
    maxWidth: 50,
    position: 'fixed',
    zIndex: 1,
    top: '30vh',
    left: 50,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      left: 6,
    },
    [theme.breakpoints.down('xs')]: {
      top: '35%',
      left: 2,
      width: 20,
      maxWidth: 20,
    },
  },
  shareButton: {
    [theme.breakpoints.down('xs')]: {
      width: 20,
      height: 20,
    },
  },
  shareIcon: {
    '&:hover': {
      opacity: 0.7,
    },
    [theme.breakpoints.down('xs')]: {
      width: 20,
      height: 20,
    },
  },
})

const Shares = (props) => {
  const { classes, data, url } = props

  return data.map((shareProps, i) => {
    const { shareButton, icon, ...otherProps } = shareProps
    const ShareButton = shareButton
    const Icon = icon

    const size = 45

    return (
      <div key={`ficon${i}`} style={{ marginBottom: 8 }}>
        <ShareButton
          style={{ cursor: 'pointer', width: size }}
          url={url}
          className={classes.shareButton}
          {...otherProps}
        >
          <Icon className={classes.shareIcon} size={size} />
        </ShareButton>
      </div>
    )
  })
}

Shares.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  url: PropTypes.string.isRequired,
}

const FloatingSidebar = (props) => {
  const { classes, shareLink, title, thumbnail, ...otherProps } = props

  const data = [
    {
      shareButton: PinterestShareButton,
      icon: PinterestIcon,
      description: title,
      media: thumbnail,
      countIcon: PinterestShareCount,
    },
    {
      shareButton: TwitterShareButton,
      icon: TwitterIcon,
      title,
      via: 'healthfulinspir',
    },
    {
      shareButton: FacebookShareButton,
      icon: FacebookIcon,
      quote: title,
      via: 'healthfulinspir',
    },
    {
      shareButton: GooglePlusShareButton,
      icon: GooglePlusIcon,
    },
    {
      shareButton: TumblrShareButton,
      icon: TumblrIcon,
    },
    {
      shareButton: RedditShareButton,
      icon: RedditIcon,
      title,
    },
  ]

  return (
    <div className={classes.root} {...otherProps}>
      <Shares classes={classes} data={data} url={shareLink} />
    </div>
  )
}

FloatingSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  shareLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
}

export default withStyles(styles)(FloatingSidebar)



// WEBPACK FOOTER //
// ./src/components/FloatingSidebar.js